import React, { useState, useEffect } from "react";
import { Grid, Header } from "semantic-ui-react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "./styles/styles.css";

import {
  formatCurrency,
  formatterUSD,
} from "../../../../../commons/functions/generalFunctions";

const CarouselNewItem = (props) => {
  const { currencySelect } = props;
  const { images, name, code, price, id } = props.array;
  const image = JSON.parse(images[0]).url;

  const [currencyValue, SetCurrencyValue] = useState(0);
  useEffect(() => {
    if (currencySelect.currency.currency === "USD") {
      SetCurrencyValue(currencySelect.currency.currencyLayer);
    } else {
      SetCurrencyValue(0);
    }
  }, [currencySelect]);

  let message;

  message = (
    <Grid.Column className="colum2-CarouselNewItem">
      <div className="div-button-CarouselNewItem">
        {name === "" ? null : <Header as="h2">{name}</Header>}
        {name === "" ? (
          <Header as="h2">{code}</Header>
        ) : (
          <p className="code">{code}</p>
        )}
        <p className="price">
          {props.currencySelect !== undefined && props.currencySelect.loading
            ? "Cargando..."
            : currencyValue === 0
            ? formatCurrency(Math.ceil(price))
            : formatterUSD.format(
                Math.ceil(price / currencyValue.data.value) - 0.01
              )}
        </p>
        <Link
          to={`/product/${id}`}
          className="text-decoration-none text-dark"
          onClick={() => window.scrollTo(0, 0)}
        >
          <button className="button-CarouselNewItem">Ver Producto</button>
        </Link>
      </div>
    </Grid.Column>
  );

  return (
    <Grid padded columns={2} className="grid-CarouselNewItem">
      <Grid.Column className="colum1-CarouselNewItem">
        <div
          className="Image-CarouselNewItem customizableImage"
          style={{
            backgroundImage: `url(${image})`,
          }}
        ></div>
      </Grid.Column>

      {message}
    </Grid>
  );
};
const mapStateToProps = (state) => {
  return {
    currencySelect: state.currencySelect,
  };
};

export default connect(mapStateToProps)(CarouselNewItem);
